export const PATH_DEVICE = "/device";

export function setDeviceInfoAPI(args) {
    return this.http.patch(`${PATH_DEVICE}/settings`, args);
}
